import React from 'react';
import { FlightTicketPropType } from '../../../../PropTypes';
import { Form, Col, Row } from 'react-bootstrap';

const StaffInfoSection = ({ flyToWorkTicketInfo }) => (
  <>
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Staff Source Market</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.staffSourceMarket || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Source Market Budget</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.staffSourceMarketBudget || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Season</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.season || ''} disabled />
      </Form.Group>
    </Row>
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Country</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.country || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Destination</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.destination || ''} disabled />
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>IATA Code</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.iataCode || ''} disabled />
      </Form.Group>
    </Row>
    <Row>
      <Form.Group as={Col}>
        <Form.Label>Position Job title</Form.Label>
        <Form.Control type="text" defaultValue={flyToWorkTicketInfo.jobTitle || ''} disabled />
      </Form.Group>
    </Row>
  </>
);

StaffInfoSection.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
};

export default React.memo(StaffInfoSection);
